"use client";
import { Link, usePathname } from "@/i18n/routing";
import {
  Badge,
  Button,
  cn,
  Divider,
  Image as HeroImage,
  Navbar as HeroNavbar,
  NavbarContent,
  NavbarItem,
  useDisclosure,
} from "@heroui/react";
import _ from "lodash";
import { useLocale, useTranslations } from "next-intl";
import { useCallback, useEffect } from "react";
import { IoIosGlobe, IoIosMenu, IoMdNotifications } from "react-icons/io";
import { useModal } from "@/components/contexts/modal";
import LanguageModal from "@/components/language-modal";
import MobileMenu from "@/components/mobile-menu";
import MenuContent from "@/components/menu-content";
import NavbarLoginRegister from "@/components/navbar-login-register";
import $ from "jquery";
import NavbarUserDetails from "@/components/navbar-user-details";
import useNotification from "./hooks/use-notification";
export default function Navbar({ isLoggedIn }: { isLoggedIn: boolean }) {
  const {
    isOpen: isMobileMenuOpen,
    onOpenChange: onMobileMenuOpenChange,
    onOpen: onMobileMenuOpen,
    onClose: onMobileMenuClose,
  } = useDisclosure();
  function OnResize(
    e: JQuery.ResizeEvent<Window & typeof globalThis, undefined, Window & typeof globalThis, Window & typeof globalThis>
  ) {
    // console.log(e.currentTarget.innerWidth);
    if (innerWidth >= 1024) {
      onMobileMenuClose();
    }
  }
  useEffect(() => {
    $(() => {
      $(window).on("resize", OnResize);
    });

    return () => {
      $(window).off("resize", OnResize);
    };
  }, []);

  const locale = useLocale();
  const pathname = usePathname();

  const { openModal } = useModal();
  const t = useTranslations();
  const openLanguageSwitchModal = useCallback(() => openModal(<LanguageModal />, t("Language")), [locale]);
  const [notifications] = useNotification(isLoggedIn);
  const BrandIcon = ({ className }: { className?: string }) => (
    <NavbarItem className={cn(className)}>
      <Link href={"/"} className="mb-2">
        <HeroImage src="/maha_logo1.webp" width={128} radius="none" />
      </Link>
    </NavbarItem>
  );

  const DesktopNavLink = {
    home: "/",
    promotion: "/promotion",
    wallet: "/wallet",
    referral: "/referral",
    // profile: "/profile",
  };

  useEffect(() => {
    if (window) {
      window.openMenu = () => onMobileMenuOpen();
    }
  }, []);

  return (
    <>
      <MobileMenu
        isOpen={isMobileMenuOpen}
        onOpenChange={onMobileMenuOpenChange}
        menuContent={
          <MenuContent isLoggedIn={isLoggedIn} onClose={onMobileMenuClose} heightRelativeToParent="100svh" />
        }
      />
      <div className="gradient-primary flex">
        <div className="w-0 flex-none lg:w-[320px]" />
        <HeroNavbar
          position="sticky"
          height={"var(--main-navbar-height)"}
          maxWidth="full"
          isBlurred={false}
          className="shadow-lg"
          classNames={{ base: "bg-transparent", wrapper: cn("lg:max-w-screen-md px-4 md:px-2"), content: "gap-2" }}
        >
          <NavbarContent justify="start" className="">
            {/* Mobile */}
            <NavbarItem className="md:hidden">
              <Button isIconOnly variant="light" onPress={() => onMobileMenuOpen()}>
                <IoIosMenu size={24} className="text-white" />
              </Button>
            </NavbarItem>
            {/* Desktop */}
            {/* <Popover placement="bottom-start" isOpen={isDesktopMenuOpen} onOpenChange={onDesktopMenuOpenChange}>
            <PopoverTrigger>
              <NavbarItem className="hidden sm:flex" as={Button} isIconOnly variant="shadows">
                <IoIosMenu size={24} className="text-white" />
              </NavbarItem>
            </PopoverTrigger>
            <PopoverContent>
              <div className="h-[calc(100svh-5rem)] max-h-[480px] w-[320px]">
                <MenuContent isLoggedIn={isLoggedIn} onClose={onDesktopMenuClose} heightRelativeToParent="100%" />
              </div>
            </PopoverContent>
          </Popover> */}
            <BrandIcon className="hidden flex-none sm:flex" />
            <NavbarItem className="hidden justify-center gap-4 md:flex">
              {_.toPairs(DesktopNavLink).map(([key, href]) => (
                <Link
                  key={key}
                  href={href}
                  className={cn(
                    "min-w-20 rounded-md p-2 text-center text-small transition-background hover:bg-black/25",
                    {
                      "gradient-secondary font-bold text-white": pathname === href,
                    }
                  )}
                >
                  {t(key)}
                </Link>
              ))}
            </NavbarItem>
          </NavbarContent>
          <NavbarContent justify="center">
            <BrandIcon className="sm:hidden" />
          </NavbarContent>
          <NavbarContent justify="end">
            <NavbarItem className="hidden h-full items-center gap-2 py-4 sm:flex">
              {(!isLoggedIn && <NavbarLoginRegister />) || <NavbarUserDetails />}
            </NavbarItem>
            {typeof process.env.NEXT_PUBLIC_ENABLE_NOTIFICATION !== "undefined" &&
              process.env.NEXT_PUBLIC_ENABLE_NOTIFICATION === "true" &&
              isLoggedIn && (
                <NavbarItem>
                  <Badge
                    as={"div"}
                    content={
                      <span className="text-[0.8em] leading-none">
                        {notifications?.filter((e) => e.status === "1").length || 0}
                      </span>
                    }
                    classNames={{
                      badge: cn(
                        "bg-none size-[1.25rem] bg-danger border-none leading-none flex justify-center items-center"
                      ),
                    }}
                  >
                    <Button
                      as={Link}
                      href="/notifications"
                      isIconOnly
                      className="border-none p-1 text-white"
                      variant="ghost"
                    >
                      <IoMdNotifications size={24} />
                    </Button>
                  </Badge>
                </NavbarItem>
              )}
            <NavbarItem>
              <Button
                onPress={openLanguageSwitchModal}
                isIconOnly
                className="border-none p-1 text-white"
                variant="ghost"
              >
                <IoIosGlobe size={24} />
              </Button>
            </NavbarItem>
          </NavbarContent>
        </HeroNavbar>
      </div>
    </>
  );
}
